module.exports = __webpack_public_path__ + "img/36.1fabd81b.svg";